import {Injectable} from '@angular/core';
import {v4 as uuidv4} from 'uuid';

@Injectable()
export class UuidGeneratorService {

  generateUuId(): string {
    return uuidv4();
  }
}
